export default [
    { name: 'Cizplam<sup>\u00AE</sup> (Placebetron Axetil)', ndc: '10001-0101-01', promoId: [ 1667 ] },
    { name: 'Authorized Generic of Cizplam<sup>\u00AE</sup> (Placebetron Axetil) tablets', ndc: '10001-2101-01', promoId: [ 1667 ] },
];
